import merge from 'lodash/merge';
import App from './views/App.svelte';
import WhispererSearchService from './services/whisperer-search.service';
import SearchService from './services/search.service';
import ServiceProvider from './services/service.provider';
import DataProvider from './services/data.provider';
import AppList from './views/AppList.svelte';
class SearchApp {
    constructor(options) {
        this.options = options;
    }
    mount() {
        try {
            this.prepareOptions();
            this.dataProvider = new DataProvider(this.options);
            const whispererSearchService = new WhispererSearchService(this.dataProvider);
            const searchService = new SearchService(this.dataProvider);
            this.serviceProvider = new ServiceProvider(whispererSearchService, searchService);
            this.createInstance();
        }
        catch (e) {
            console.log(e);
        }
    }
    createInstance() {
        new App({
            target: this.targetElement,
            props: {
                serviceProvider: this.serviceProvider,
                dataProvider: this.dataProvider
            }
        });
        if (this.options.submitTarget) {
            new AppList({
                target: document.querySelector(this.options.submitTarget),
                props: {
                    serviceProvider: this.serviceProvider,
                    dataProvider: this.dataProvider
                }
            });
        }
    }
    get targetElement() {
        const { el } = this.options;
        const element = document.querySelector(el);
        if (null === element) {
            throw new Error("The container for displaying Search does not exist");
        }
        return element;
    }
    // OPTIONS
    prepareOptions() {
        this.options = merge({}, {
            el: null,
            placeholder: null,
            cta: null,
            submitTarget: null,
            structureKeys: null,
            showSiteUrl: null,
            resultUrl: null,
            template: null,
            groupId: null,
            endpoint: null,
            locale: {
                placeholder: '',
                cta: '',
                empty: ''
            }
        }, this.options);
    }
}
function mountSearch(element) {
    const structureKeys = element.getAttribute('data-structure-keys') || null;
    const groupId = element.getAttribute('data-group-id') || null;
    const endpoint = element.getAttribute('data-endpoint') || null;
    const showSiteUrl = element.getAttribute('data-show-site-url') || 'false';
    const submitTarget = element.getAttribute('data-submit-target') || null; //'#search-list-module'
    const cta = element.getAttribute('data-cta') || 'Hledat';
    const placeholder = element.getAttribute('data-placeholder') || 'Vyhledat...';
    const noResults = element.getAttribute('data-no-results') || 'Nepodařilo se dohledat žádné výsledky';
    const resultUrl = element.getAttribute('data-result-url') || null;
    const template = element.getAttribute('data-template') || null;
    element.innerHTML = '';
    const searchApp = new SearchApp({
        structureKeys,
        showSiteUrl,
        submitTarget,
        el: "#" + element.id,
        cta,
        placeholder,
        noResults,
        resultUrl,
        template,
        groupId,
        endpoint,
    });
    void searchApp.mount();
}
const searchWhispererModule = document.getElementById('search-whisperer-module');
const searchHeaderModule = document.getElementById('search-whisperer-header-module');
const searchFooterModule = document.getElementById('search-whisperer-footer-module');
if (searchWhispererModule) {
    mountSearch(searchWhispererModule);
}
if (searchHeaderModule) {
    mountSearch(searchHeaderModule);
}
if (searchFooterModule) {
    mountSearch(searchFooterModule);
}
